import { useContext } from 'react';
import ThemeContrast from './ThemeContrast';
import ThemeRtlLayout from './ThemeRtlLayout';
import ThemeColorPresets from './ThemeColorPresets';
import SettingsDrawer from './drawer';
import UserContext from '../../context/UserProvider/UserContext';

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

/**
 * Globaler Mount-Punkt für Theme-Wrapper + Einstellungs-Toggle/Drawer.
 * Toggle und Drawer werden nur gerendert, wenn der Auth-/User-Context
 * einen ermittelten Nutzer liefert (id truthy) — sonst null, kein DOM.
 */
export default function ThemeSettings({ children }: Props) {
  const user = useContext(UserContext);
  // defaultValues hat id: 0; eingeloggte Nutzer haben eine echte id (> 0).
  // Explizites null (z. B. in Tests) → ebenfalls kein Render.
  const hasUser = user != null && Boolean(user.id);

  return (
    <ThemeColorPresets>
      <ThemeContrast>
        <ThemeRtlLayout>
          {children}
          {hasUser ? <SettingsDrawer /> : null}
        </ThemeRtlLayout>
      </ThemeContrast>
    </ThemeColorPresets>
  );
}
